import {authHeader} from '../backend'
import {handleResponse} from './handleResponse'

export const clubInfoService = {
  getClubInfoList
}

function getClubInfoList (activeStatus, manageStatus, aplStatus, searchValue) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }

  let queryString = `?`
  if (activeStatus !== undefined && activeStatus !== '') {
    queryString += `activeStatus=${activeStatus}&`
  }
  if (manageStatus !== undefined && manageStatus !== '') {
    queryString += `manageStatus=${manageStatus}&`
  }
  if (aplStatus !== undefined && aplStatus !== '') {
    queryString += `aplStatus=${aplStatus}&`
  }
  if (searchValue !== undefined && searchValue !== '') {
    queryString += `searchValue=${encodeURI(searchValue)}&`
  }
  return fetch(`${process.env.BASE_API}/setting/club-info/list/all${queryString}` + Date.now(), requestOptions).then(handleResponse)
}



// WEBPACK FOOTER //
// ./src/router/clubInfoRouter.js